import { render, staticRenderFns } from "./DeviceLayout.vue?vue&type=template&id=864c94c8&scoped=true&"
import script from "./DeviceLayout.vue?vue&type=script&lang=js&"
export * from "./DeviceLayout.vue?vue&type=script&lang=js&"
import style0 from "./DeviceLayout.vue?vue&type=style&index=0&id=864c94c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c94c8",
  null
  
)

export default component.exports